import React from "react";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import CustomTable from "../../../../components/table/CustomTable";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import ConfirmModal from "../../../Dashboard/Visitor/Invitation/Modal/ConfirmModal";
import CopyInvitationLinkModal from "../../../Dashboard/Visitor/Invitation/Modal/CopyInvitationLinkModal";
import InviteAgainModal from "../../Modal/InviteAgainModal";
import MyApartmentInvitationModal from "../../Modal/MyApartmentInvitationModal";
import { MyApartmentInvitationsTableApp } from "../../Functionality/MyApartmentInvitationsTableApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Visits of the resident, listed on the invitations tab of my building with the
 * details, invitation link and cancel actions of every row.
 *
 * @param {Object} props
 * @param {Object} props.buildingDetail - Apartment of the logged resident, the invitations are searched with it.
 * @param {Function} props.onInvite - Opens the invite external user modal, the empty list calls it too.
 * @param {boolean} props.modified - Flag raised when the list has to be reloaded.
 * @param {Function} props.setModified - Lowers the flag once the list is loaded again.
 */
const MyApartmentInvitationsTable = ({ buildingDetail, onInvite, modified, setModified }) => {
    const {
        t,
        tableId,
        searchId,
        option,
        searchElement,
        setSearchElement,
        setResults,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        handleSearch,
        handleResetSearch,
        thead,
        tbody,
        detailsModal,
        hideDetails,
        invitationLinkModal,
        setInvitationLinkModal,
        cancelModal,
        inviteAgainModal,
        itemSelected,
        setItemSelected,
        hideCancel,
        hideInviteAgain,
        handleCancel,
        getActionsButtons,
        pagination,
        elementRef
    } = MyApartmentInvitationsTableApp({
        zoneId: buildingDetail?.zoneId,
        modified,
        setModified
    });

    return (
        <>
            <div className="row mt-4 flex-shrink-0">
                <div className={"col-12 px-0"}>
                    <SearchSimple
                        id={searchId}
                        label={'search_by_name'}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearchResults={setResults}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        callApi={handleSearch}
                        resetApi={handleResetSearch}
                    />
                </div>
            </div>

            {/* Both scrolls live here: the table has no height of its own and the
                columns keep their measured width, so the row does not wrap */}
            <div className={"panelTables-container custom-scrollbar"} ref={elementRef}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    textNotInformation={'you_haven_not_created_any_invitation'}
                    withoutHeight={true}
                    /* The empty list offers the same action of the tab, a search
                       without results is not the place to invite a visitor */
                    childrenNotInformation={tbody?.body?.length === 0 && searchElement === "" ? <>
                        <div className={"warning-text"}>
                            <p>{t('you_haven_not_created_any_invitation')}</p>
                        </div>
                        <CustomButtonLink
                            splitName={false}
                            id={'btn_mbit_invite'}
                            card={true}
                            onClick={onInvite}
                            name={'invite'}
                        />
                    </> : undefined}
                />
            </div>

            <div className={"flex-shrink-0"}>
                {pagination()}
            </div>

            {detailsModal && itemSelected &&
                <MyApartmentInvitationModal
                    show={detailsModal}
                    onHide={hideDetails}
                    itemSelected={itemSelected}
                />
            }

            <ConfirmModal
                show={cancelModal}
                onHide={hideCancel}
                onClickFn={handleCancel}
                title_modal={'cancel_invitation'}
                description={t('are_you_sure_you_want_to_cancel_the_invitation')}
            />

            {inviteAgainModal && itemSelected &&
                <InviteAgainModal
                    show={inviteAgainModal}
                    onHide={hideInviteAgain}
                    itemSelected={itemSelected}
                    setModified={setModified}
                />
            }

            {invitationLinkModal && itemSelected &&
                <CopyInvitationLinkModal
                    show={invitationLinkModal}
                    setShow={setInvitationLinkModal}
                    itemSelected={itemSelected}
                    setItemSelected={setItemSelected}
                    descriptionKey={"share_this_secure_link_with_the_visitor_so_they_can_complete_the_required_information"}
                    warningKey={"this_link_is_unique_and_should_only_be_shared_with_the_invited_visitor"}
                />
            }
        </>
    );
};

export default MyApartmentInvitationsTable;
